import BonusTemplates from "./bonus-templates";

export default BonusTemplates;
